module.exports = __webpack_public_path__ + "media/bootstrap-icons/pause-circle-5bafbdf0.svg";